import {ReactNode} from 'react';
import {Button, css, Spinner} from '@sail/ui/deprecated';
import {useTheme} from '@stripe-internal/conversations-ui';

type Props = {
  onPress: () => void;
  disabled?: boolean;
  pending?: boolean;
  dataTestId?: string;
  children: ReactNode;
  size?: 'small' | 'medium' | 'large';
};

export function BrandedPrimaryButton({
  onPress,
  disabled,
  pending,
  dataTestId,
  children,
  size = 'large',
}: Props) {
  const theme = useTheme();

  return (
    <Button
      size={size}
      type={'primary'}
      css={{
        width: 'fill',
        color: css.value(theme.onCtaTextColor),
        backgroundColor: css.value(theme.ctaColor),
        borderColor: css.value(theme.ctaColor),
        outlineColor: css.value(theme.ctaColor),
        '--button-background-color': css.value(theme.ctaColor),
        '--keyline': css.value(theme.ctaColor),
        keyline: css.value(theme.ctaColor),
        '&:hover': {
          backgroundColor: disabled
            ? css.value(theme.ctaColor)
            : css.value(theme.ctaHoverColor),
        },
        '&:focus': {
          outline: theme.focusVisibleOutline,
          focusRing: theme.focusVisibleOutline ? css.value('none') : undefined,
        },
      }}
      onPress={onPress}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {pending ? <Spinner /> : children}
    </Button>
  );
}
